import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../index'

interface AuthorsState {
  modalOpen: boolean
  selectedAuthorId: number | null
  hoveredAuthorId: number | null
}

const initialState: AuthorsState = {
  modalOpen: false,
  selectedAuthorId: null,
  hoveredAuthorId: null,
}

export const authorsSlice = createSlice({
  name: 'authors',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<number>) => {
      state.modalOpen = true
      state.selectedAuthorId = action.payload
    },
    closeModal: (state) => {
      state.modalOpen = false
      state.selectedAuthorId = null
    },
    setHoveredAuthor: (state, action: PayloadAction<number | null>) => {
      state.hoveredAuthorId = action.payload
    },
  },
})

export const { openModal, closeModal, setHoveredAuthor } = authorsSlice.actions

export const selectAuthorsState = (state: RootState) => state.authors
export const selectModalOpen = (state: RootState) => state.authors.modalOpen
export const selectSelectedAuthorId = (state: RootState) => state.authors.selectedAuthorId
export const selectHoveredAuthorId = (state: RootState) => state.authors.hoveredAuthorId

export default authorsSlice.reducer
